import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  ModalBody,
  UncontrolledTooltip,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Badge,
  FormGroup,
  Label,
  ModalFooter,
  ModalHeader,
  FormFeedback,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { corporateCustomer } from "../../../common/data/MyFackData";
import quoteImage from "../../../assets/images/product/Pro-12b.png";
import CorporateCustomerCart from "../../../components/CorporateCart/CorporateCustomerCart";
import CorporatePaymentTerms from "./CorporatePaymentTerms";
import CorporateCustomerAdd from "./CorporateCustomerAdd";
import CorporateAddress from "./CorporateAddress";
import { Formik, Form, Field, ErrorMessage,useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

const CorporateDetail = () => {

    const { id } = useParams();
    const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;

  const [customer, setCustomer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [newRegisterAs, setNewRegisterAs] = useState("");
  const [selectedRegisterAs, setSelectedRegisterAs] = useState("");
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "1"
  );
  const [modal, setModal] = useState(false);
  const [customerModal, setCustomerModal] = useState(false);
  const [quotes, setQuotes] = useState([
    {
      quoteNumber: "Q-1025",
      userName: "Ankit Gandhi",
      mobileNumber: "1234567890",
      role: "Technician",
      date: "28-02-2024",
      revisedDate: "28-02-2024",
      status: "Expired",
      products: [
        {
          productCode: "P-101",
          productImage: "path/to/image1",
          productName: "Product 1",
          orderQty: 10,
          actualPrice: 50,
          quotedPrice: 45,
          yourPrice: 40,
          currentStocks: 50,
          deliverySchedule: "4-5 Weeks",
        },
        {
          productCode: "P-102",
          productImage: "path/to/image2",
          productName: "Product 2",
          orderQty: 20,
          actualPrice: 60,
          quotedPrice: 55,
          yourPrice: 50,
          currentStocks: 30,
          deliverySchedule: "4-5 Weeks",
        },
      ],
    },
    {
      quoteNumber: "Q-1026",
      userName: "John Doe",
      mobileNumber: "1234567890",
      role: "Technician",
      date: "28-02-2024",
      revisedDate: "28-02-2024",
      status: "Revised",
      products: [
        {
          productCode: "P-103",
          productImage: "path/to/image3",
          productName: "Product 3",
          orderQty: 15,
          actualPrice: 70,
          quotedPrice: 65,
          yourPrice: 60,
          currentStocks: 20,
          deliverySchedule: "4-5 Weeks",
        },
      ],
    },
  ]);
  const [addProduct, setAddProduct] = useState(null);
  const [editQuote, setEditQuote] = useState(null);
  const [quoteModel, setQuoteModel] = useState(false);

    const [paymentDetailsModel, setPaymentDetailsModal] = useState(false);
    const [trackingDetailsModel, setTrackingDetailsModal] = useState(false);

  const handleQuoteEdit = (customer) => {
    setEditQuote(customer.quoteNumber);
  };

  const toggleModal = () => setModal(!modal);


  // 🔹 Validation
  const validationSchema = Yup.object({
  discount: Yup.number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0")
    .max(100, "Discount cannot be more than 100")
    .required("Discount is required"),

  industry: Yup.string()
    .trim()
    .required("Industry is required"),

  customer_type: Yup.string()
    .trim()
    .required("Customer type is required"),

  customer_category: Yup.string()
    .trim()
    .required("Customer category is required"),

  status: Yup.string()
    .oneOf(
      ["Active", "Inactive"],
      "Invalid status"
    )
    .required("Status is required"),
});

  // 🔹 Modal toggles
  const toggleRegisterModal = () => setShowModal(!showModal);
  const toggleCustomerModal = () => setCustomerModal(!customerModal);
  const togglePaymentDetailsViewModal = () => setPaymentDetailsModal(!paymentDetailsModel);
  const toggleTrackingDetailsViewModal = () => setTrackingDetailsModal(!trackingDetailsModel);

  // 🔹 Update customer handler
  const handleSubmit = async (values, { setSubmitting }) => {
  try {
    const res = await fetch(
      `${baseurl}/admin/customer/corporates/${customer.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("Customer updated successfully");

      // 🔥 Update local state so UI updates instantly
      setCustomer(prev => ({
        ...prev,
        ...data.data,
      }));

      toggleCustomerModal();
    } else {
      toast.error(data.message || "Update failed");
    }
  } catch (error) {
    console.error("Update customer error:", error);
    toast.error("Something went wrong");
  } finally {
    setSubmitting(false);
  }
};

  const handleEditClicks = (product) => {
    toggleModal();
    setAddProduct(product);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (addProduct && addProduct.productCode) || "",
      actualPrice: (addProduct && addProduct.actualPrice) || "",
      quotedPrice: (addProduct && addProduct.quotedPrice) || "",
      yourPrice: (addProduct && addProduct.yourPrice) || "",
    },
    validationSchema: Yup.object({
      actualPrice: Yup.string().required("Please enter actual price"),
      quotedPrice: Yup.string().required("Please enter quoted price"),
      yourPrice: Yup.string().required("Please enter your price"),
    }),
    onSubmit: (values) => {
      console.log(":", values);
      toggleModal();
      toast.success("Quote edit successfully!!");
    },
  });

  const toggleQuoteModal = () => setQuoteModel(!quoteModel);

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  // 🔹 Fetch individual customer detail
  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const res = await fetch(`${baseurl}/admin/customer/corporates/${id}`);
        const data = await res.json();

        if (data.success) {
          setCustomer(data.data);
          setActiveTab("1");
          
        } else {
          toast.error("Customer not found!");
        }
      } catch (error) {
        console.error("Fetch customer error:", error);
        toast.error("Error fetching customer details.");
      }
    };
    fetchCustomer();
  }, [id, baseurl]);

  if (!customer) return <div>Loading...</div>;

  const handleRegisterAsChange = (event) => {
    setNewRegisterAs(event.target.value);
    setSelectedRegisterAs(event.target.value);
    setShowModal(true);
  };

  const handleConfirm = () => {
    console.log("newRegisterAs", newRegisterAs);
    setShowModal(false);
  };

  document.title = "Corporate customer details | Vekart";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Manage Customers"
          breadcrumbItem="Customer Details"
        />

        <Row>
          <Col lg="3">
            <Card>
              <CardBody className="text-center d-flex justify-content-center align-items-center">
                            {customer.image ? (
                              <img
                                src={`${imgurl}${customer.image}`}
                                alt="Profile"
                                className="rounded-circle"
                                width="100"
                                height="100"
                              />
                            ) : (
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  borderRadius: "50%",
                                  backgroundColor: "#ddd",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "80px",
                                  fontWeight: "bold",
                                  color: "#555",
                                }}
                              >
                                {customer.company_name?.slice(0, 2).toUpperCase()}
                              </div>
                            )}
              </CardBody>
            </Card>
          </Col>

          <Col lg="9">
            {/* <div className="mb-3">
              <button
                className="btn btn-success d-flex align-items-center"
                style={{
                  fontSize: "16px",
                  borderRadius: "15px",
                  padding: "10px 20px",
                  fontWeight: "600",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <i
                  className="mdi mdi-shield-check me-2"
                  style={{ fontSize: "20px" }}
                ></i>
                Verified
              </button>
            </div> */}
            <div className="table-responsive">
              <table
                className="table table-bordered"
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              >
                <table className="table table-bordered bg-light">
                              <tbody>
                                <tr>
                                  <th>Customer ID</th>
                                  <td>{customer.id}</td>
                                </tr>
                                <tr>
                                  <th>Company Name</th>
                                  <td>{customer.company_name || "N/A"}</td>
                                </tr>
                                <tr>
                                  <th>GST Number</th>
                                  <td>{customer.gst_number || "N/A"}</td>
                                </tr>
                                <tr>
                                  <th>PAN Card Number</th>
                                  <td>{customer.pan_number || "N/A"}</td>
                                </tr>
                                <tr>
                                  <th>Industry</th>
                                  <td>{customer.industry || "N/A"}</td>
                                </tr>
                                <tr>
                                  <th>Customer Type</th>
                                  <td>{customer.customer_type || "N/A"}</td>
                                </tr>
                                <tr>
                                  <th>Customer Category</th>
                                  <td>{customer.customer_category || "N/A"}</td>
                                </tr>
                                <tr>
                                  <th>Discount</th>
                                  <td>{customer.discount || "0"} %</td>
                                </tr>
                                <tr>
                                  <th>Status</th>
                                  <td>
                                    <span className={`badge ${customer.status === "Active" ? "bg-success" : "bg-danger"}`}>
                                      {customer.status}
                                    </span>
                                    <Link to="#" onClick={toggleCustomerModal} className="ms-2 text-success">
                                      <i className="mdi mdi-pencil font-size-18"></i>
                                    </Link>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
              </table>
            </div>
          </Col>
        </Row>

        <div className="my-3">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === "1" ? "active" : ""}
                onClick={() => setActiveTab("1")}
                style={{ cursor: "pointer" }}
              >
                Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "2" ? "active" : ""}
                onClick={() => setActiveTab("2")}
                style={{ cursor: "pointer" }}
              >
                Addresses
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "3" ? "active" : ""}
                onClick={() => setActiveTab("3")}
                style={{ cursor: "pointer" }}
              >
                Carts
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "4" ? "active" : ""}
                onClick={() => setActiveTab("4")}
                style={{ cursor: "pointer" }}
              >
                Orders
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "5" ? "active" : ""}
                onClick={() => setActiveTab("5")}
                style={{ cursor: "pointer" }}
              >
                Invoices
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "6" ? "active" : ""}
                onClick={() => setActiveTab("6")}
                style={{ cursor: "pointer" }}
              >
                Payment
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "7" ? "active" : ""}
                onClick={() => setActiveTab("7")}
                style={{ cursor: "pointer" }}
              >
                Shipment
              </NavLink>
            </NavItem>
          </Nav>
        </div>

        <TabContent activeTab={activeTab} className="mt-3">
          {activeTab === "1" && (
            <TabPane tabId="1">
              <CorporatePaymentTerms />
              <CorporateCustomerAdd  users={customer?.users} />

              

              
            </TabPane>
          )}

          {activeTab === "2" && (
            <TabPane tabId="2">
              <Row className="d-flex justify-content-between align-items-center mb-2">
                <Col lg="6">
                  <h5 className="m-0">Manage Addresses</h5>
                </Col>
              </Row>
              

              <CorporateAddress  userId={customer?.id} />
            </TabPane>
          )}

          {activeTab === "3" && (
            <TabPane tabId="3">
              <Row className="d-flex justify-content-between align-items-center mb-2">
                <Col lg="6">
                  <h5 className="m-0">Manage Carts</h5>
                </Col>
                <Col lg="12">
                  <CorporateCustomerCart userIds={customer?.userids} />
                </Col>
              </Row>
            </TabPane>
          )}

          {activeTab === "4" && (
            <TabPane tabId="4">
              <Row className="d-flex justify-content-between align-items-center mb-2">
                <Col lg="6">
                  <h5 className="m-0">Manage Orders</h5>
                </Col>
              </Row>
            </TabPane>
          )}

          {activeTab === "5" && (
            <TabPane tabId="5">
              <Row className="d-flex justify-content-between align-items-center mb-2">
                <Col lg="6">
                  <h5 className="m-0">Manage Invoices</h5>
                </Col>
              </Row>
            </TabPane>
          )}

          {activeTab === "6" && (
            <TabPane tabId="6">
              <Row className="d-flex justify-content-between align-items-center mb-2">
                <Col lg="6">
                  <h5 className="m-0">Manage Payment</h5>
                </Col>
              </Row>
            </TabPane>
          )}

          {activeTab === "7" && (
            <TabPane tabId="7">
              <Row className="d-flex justify-content-between align-items-center mb-2">
                <Col lg="6">
                  <h5 className="m-0">Manage Shipment </h5>
                </Col>
              </Row>
            </TabPane>
          )}
        </TabContent>

        {/* Modal for Change Register As*/}
        <Modal
          size="sm"
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          centered={true}
        >
          <div className="modal-content">
            <ModalBody className="px-4 py-5 text-center">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="btn-close position-absolute end-0 top-0 m-3"
              ></button>
              <p className="text-muted font-size-16 mb-4">
                Are you sure you want to permanently change customer As -{" "}
                <b>{selectedRegisterAs}</b>
              </p>

              <div className="hstack gap-2 justify-content-center mb-0">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirm}
                >
                  Yes
                </button>
              </div>
            </ModalBody>
          </div>
        </Modal>

        {/* Model for quote */}
        <Modal
          isOpen={quoteModel}
          toggle={toggleQuoteModal}
          backdrop="static"
          size="lg"
        >
          <ModalHeader toggle={toggleQuoteModal}>Quote Calculation</ModalHeader>
          <div className="modal-content">
            <ModalBody>
              <Row>
                <Col lg="6" className="mb-2">
                  <h5 className="m-0">Product Name</h5>
                </Col>
                <Col lg="12">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      style={{
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    >
                      <thead>
                        <tr>
                          <th>Purchase Price</th>
                          <th>Loading</th>
                          <th>Cost Price</th>
                          <th>Margin</th>
                          <th>Minimum Selling Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹200</td>
                          <td>2%</td>
                          <td>₹204</td>
                          <td>15%</td>
                          <td>Rs. 240</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg="6" className="mb-2">
                  <h5 className="m-0">Quoted Price History</h5>
                </Col>
                <Col lg="12">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      style={{
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    >
                      <thead>
                        <tr>
                          <th>Qty.</th>
                          <th>Quoted Amount</th>
                          <th>User Name</th>
                          <th>Quote Submission Date</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>₹250</td>
                          <td>Animesh Choksi</td>
                          <td>20-02-2025</td>
                          <td>test</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            </ModalBody>
          </div>
        </Modal>

        <Modal
          isOpen={modal}
          toggle={toggleModal}
          backdrop="static"
          keyboard={false}
        >
          <ModalHeader toggle={toggleModal} tag="h4">
            Edit quote
          </ModalHeader>
          <ModalBody>
            <form onSubmit={formik.handleSubmit}>
              <Row>
                <Col className="col-12">
                  <div className="mb-3">
                    <Label className="form-label">Actual Price</Label>
                    <Input
                      name="actualPrice"
                      type="text"
                      placeholder="Insert Actual Price"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.actualPrice}
                      invalid={
                        formik.touched.actualPrice && formik.errors.actualPrice
                          ? true
                          : false
                      }
                    />
                    {formik.touched.actualPrice && formik.errors.actualPrice ? (
                      <FormFeedback type="invalid">
                        {formik.errors.actualPrice}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col className="col-12">
                  <div className="mb-3">
                    <Label className="form-label">Quoted Price </Label>
                    <Input
                      name="quotedPrice"
                      type="text"
                      placeholder="Insert Quoted Price	"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.quotedPrice}
                      invalid={
                        formik.touched.quotedPrice && formik.errors.quotedPrice
                          ? true
                          : false
                      }
                    />
                    {formik.touched.quotedPrice && formik.errors.quotedPrice ? (
                      <FormFeedback type="invalid">
                        {formik.errors.quotedPrice}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col className="col-12">
                  <div className="mb-3">
                    <Label className="form-label">Your Price</Label>
                    <Input
                      name="yourPrice"
                      type="text"
                      placeholder="Insert Your Price"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.yourPrice}
                      invalid={
                        formik.touched.yourPrice && formik.errors.yourPrice
                          ? true
                          : false
                      }
                    />
                    {formik.touched.yourPrice && formik.errors.yourPrice ? (
                      <FormFeedback type="invalid">
                        {formik.errors.yourPrice}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="text-end">
                    <Button type="submit" color="success">
                      Save
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </ModalBody>
        </Modal>

        {/* Edit Customer Modal */}
                <Modal isOpen={customerModal} toggle={toggleCustomerModal} centered>
                  <ModalHeader toggle={toggleCustomerModal}>Edit Customer</ModalHeader>
                  <Formik
                    initialValues={{
                      discount: customer?.discount || "",
                      customer_category: customer?.customer_category || "",
                      industry: customer?.industry || "",
                      customer_type: customer?.customer_type || "",
                      status: customer.status || "Active",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting }) => (
                      <Form>
                        <ModalBody>
                          
                          <div className="mb-3">
                            <label>Discount (%)</label>
                            <Field name="discount" className="form-control" />
                            <ErrorMessage name="discount" component="div" className="text-danger" />
                          </div>
                          <div className="mb-3">
                            <label>Customer Category</label>
                            <Field as="select" name="customer_category" className="form-control" required>
                              <option value="">Select Customer Category</option>
                              <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                             
                            </Field>
                            <ErrorMessage name="customer_category" component="div" className="text-danger" />
                          </div>
                          <div className="mb-3">
                            <label>Industry</label>
                            <Field as="select" name="industry" className="form-control" required>
                              <option value="">Select Industry Type</option>
                              <option value="Chemical">Chemical</option>
                                <option value="Oil & Gas">Oil & Gas</option>
                                <option value="Pharma">Pharma</option>
                                <option value="Fertilizer">Fertilizer</option>
                                <option value="Food & Beverages">Food & Beverages</option>
                                <option value="Water">Water</option>
                                <option value="Renewable">Renewable</option>
                                <option value="Infra">Infra</option>
                                <option value="Automobile">Automobile</option>
                                <option value="Cement">Cement</option>
                                <option value="Pulp & Paper">Pulp & Paper</option>
                                <option value="FMCG">FMCG</option>
                                <option value="System Integrator">System Integrator</option>
                                <option value="Education">Education</option>
                                <option value="ITOT">ITOT</option>
                                <option value="Textile">Textile</option>
                                <option value="Metal">Metal</option>
                             
                            </Field>
                            <ErrorMessage name="industry" component="div" className="text-danger" />
                          </div>
                          <div className="mb-3">
                            <label>Customer Type</label>
                            <Field as="select" name="customer_type" className="form-control" required>
                              <option value="">Select Customer Type</option>
                              <option value="End User">End User</option>
                              <option value="OEM">OEM</option>
                              <option value="CP/SI">CP/SI</option>
                              <option value="EPC">EPC</option>
                              <option value="DEC">DEC</option>
                              <option value="Trader">Trader</option>
                            </Field>
                            <ErrorMessage name="customer_type" component="div" className="text-danger" />
                          </div>
                          <div className="mb-3">
                            <label>Status</label>
                            <Field as="select" name="status" className="form-control">
                              <option value="Active">Active</option>
                              <option value="Inactive">Inactive</option>
                            </Field>
                          </div>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="danger" onClick={toggleCustomerModal}>
                            Cancel
                          </Button>
                          <Button type="submit" color="primary" disabled={isSubmitting}>
                            Save Changes
                          </Button>
                        </ModalFooter>
                      </Form>
                    )}
                  </Formik>
                </Modal>
      </Container>
    </div>
  );
};

export default CorporateDetail;
